module.exports = __webpack_public_path__ + "images/_/programs/epsPrimaries/images/level-2_start-6731b6cdde1dcce9be71edea3d6d592a.png";


//////////////////
// WEBPACK FOOTER
// ./programs/epsPrimaries/images/level-2_start.png
// module id = 428
// module chunks = 2